// // // // import { useState, useRef, useEffect } from 'react';
// // // // import { useSelector } from 'react-redux';
// // // // import { FiMenu, FiBell, FiSearch, FiUser, FiLogOut, FiSettings } from 'react-icons/fi';
// // // // import { useAuth } from '../../../hooks/useAuth';
// // // // import { getInitials } from '../../../utils/formatters';
// // // // import styles from './Header.module.scss';

// // // // const Header = ({ onMenuClick }) => {
// // // //     const { user } = useSelector((state) => state.auth);
// // // //     const { logout } = useAuth();
// // // //     const [showDropdown, setShowDropdown] = useState(false);
// // // //     const [showSearch, setShowSearch] = useState(false);
// // // //     const dropdownRef = useRef(null);

// // // //     useEffect(() => {
// // // //         const handleClickOutside = (e) => {
// // // //             if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
// // // //                 setShowDropdown(false);
// // // //             }
// // // //         };
// // // //         document.addEventListener('mousedown', handleClickOutside);
// // // //         return () => document.removeEventListener('mousedown', handleClickOutside);
// // // //     }, []);

// // // //     const handleLogout = () => {
// // // //         logout();
// // // //         setShowDropdown(false);
// // // //     };

// // // //     return (
// // // //         <header className={styles.header}>
// // // //             <div className={styles.left}>
// // // //                 <button className={styles.menuBtn} onClick={onMenuClick} aria-label="Toggle menu">
// // // //                     <FiMenu size={22} />
// // // //                 </button>

// // // //                 <div className={`${styles.searchWrapper} ${showSearch ? styles.active : ''}`}>
// // // //                     <FiSearch className={styles.searchIcon} size={18} />
// // // //                     <input
// // // //                         type="text"
// // // //                         placeholder="Search..."
// // // //                         className={styles.searchInput}
// // // //                         onFocus={() => setShowSearch(true)}
// // // //                         onBlur={() => setShowSearch(false)}
// // // //                     />
// // // //                 </div>
// // // //             </div>

// // // //             <div className={styles.right}>
// // // //                 <button className={styles.iconBtn} aria-label="Notifications">
// // // //                     <FiBell size={20} />
// // // //                     <span className={styles.badge}>3</span>
// // // //                 </button>

// // // //                 <div className={styles.userMenu} ref={dropdownRef}>
// // // //                     <button
// // // //                         className={styles.userBtn}
// // // //                         onClick={() => setShowDropdown(!showDropdown)}
// // // //                     >
// // // //                         <div className={styles.avatar}>
// // // //                             {user?.avatar ? (
// // // //                                 <img src={user.avatar} alt={user.name} />
// // // //                             ) : (
// // // //                                 <span>{getInitials(user?.name || 'User')}</span>
// // // //                             )}
// // // //                         </div>
// // // //                         <div className={styles.userInfo}>
// // // //                             <span className={styles.userName}>{user?.name || 'User'}</span>
// // // //                             <span className={styles.userRole}>{user?.role || 'Admin'}</span>
// // // //                         </div>
// // // //                     </button>

// // // //                     {showDropdown && (
// // // //                         <div className={styles.dropdown}>
// // // //                             <button className={styles.dropdownItem}>
// // // //                                 <FiUser size={16} />
// // // //                                 <span>Profile</span>
// // // //                             </button>
// // // //                             <button className={styles.dropdownItem}>
// // // //                                 <FiSettings size={16} />
// // // //                                 <span>Settings</span>
// // // //                             </button>
// // // //                             <hr className={styles.divider} />
// // // //                             <button className={styles.dropdownItem} onClick={handleLogout}>
// // // //                                 <FiLogOut size={16} />
// // // //                                 <span>Logout</span>
// // // //                             </button>
// // // //                         </div>
// // // //                     )}
// // // //                 </div>
// // // //             </div>
// // // //         </header>
// // // //     );
// // // // };

// // // // export default Header;
// // // import { useState, useRef, useEffect } from 'react';
// // // import { useSelector } from 'react-redux';
// // // import { FiMenu, FiBell, FiSearch, FiUser, FiLogOut, FiSettings } from 'react-icons/fi';
// // // import { useAuth } from '../../../hooks/useAuth';
// // // import { getInitials } from '../../../utils/formatters';
// // // import styles from './Header.module.scss';

// // // const Header = ({ onMenuClick, sidebarCollapsed }) => {
// // //     const { user } = useSelector((state) => state.auth);
// // //     const { logout } = useAuth();
// // //     const [showDropdown, setShowDropdown] = useState(false);
// // //     const [showSearch, setShowSearch] = useState(false);
// // //     const dropdownRef = useRef(null);

// // //     useEffect(() => {
// // //         const handleClickOutside = (e) => {
// // //             if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
// // //                 setShowDropdown(false);
// // //             }
// // //         };
// // //         document.addEventListener('mousedown', handleClickOutside);
// // //         return () => document.removeEventListener('mousedown', handleClickOutside);
// // //     }, []);

// // //     const handleLogout = () => {
// // //         logout();
// // //         setShowDropdown(false);
// // //     };

// // //     return (
// // //         <header className={`${styles.header} ${sidebarCollapsed ? styles.collapsed : ''}`}>
// // //             <div className={styles.left}>
// // //                 {/* <button className={styles.menuBtn} onClick={onMenuClick} aria-label="Toggle menu">
// // //                     <FiMenu size={22} />
// // //                 </button> */}

// // //                 {/* <div className={`${styles.searchWrapper} ${showSearch ? styles.active : ''}`}>
// // //                     <FiSearch className={styles.searchIcon} size={18} />
// // //                     <input
// // //                         type="text"
// // //                         placeholder="Search..."
// // //                         className={styles.searchInput}
// // //                         onFocus={() => setShowSearch(true)}
// // //                         onBlur={() => setShowSearch(false)}
// // //                     />
// // //                 </div> */}
// // //             </div>

// // //             <div className={styles.right}>
// // //                 {/* <button className={styles.iconBtn} aria-label="Notifications">
// // //                     <FiBell size={20} />
// // //                     <span className={styles.badge}>3</span>
// // //                 </button> */}

// // //                 <div className={styles.userMenu} ref={dropdownRef}>
// // //                     <button
// // //                         className={styles.userBtn}
// // //                         onClick={() => setShowDropdown(!showDropdown)}
// // //                     >
// // //                         <div className={styles.avatar}>
// // //                             {user?.avatar ? (
// // //                                 <img src={user.avatar} alt={user.name} />
// // //                             ) : (
// // //                                 <span>{getInitials(user?.name || 'User')}</span>
// // //                             )}
// // //                         </div>
// // //                         <div className={styles.userInfo}>
// // //                             <span className={styles.userName}>{user?.name || 'User'}</span>
// // //                             <span className={styles.userRole}>{user?.role || 'Admin'}</span>
// // //                         </div>
// // //                     </button>

// // //                     {showDropdown && (
// // //                         <div className={styles.dropdown}>
// // //                             {/* <button className={styles.dropdownItem}>
// // //                                 <FiUser size={16} />
// // //                                 <span>Profile</span>
// // //                             </button>
// // //                             <button className={styles.dropdownItem}>
// // //                                 <FiSettings size={16} />
// // //                                 <span>Settings</span>
// // //                             </button> */}
// // //                             {/* <hr className={styles.divider} /> */}
// // //                             <button className={styles.dropdownItem} onClick={handleLogout}>
// // //                                 <FiLogOut size={16} />
// // //                                 <span>Logout</span>
// // //                             </button>
// // //                         </div>
// // //                     )}
// // //                 </div>
// // //             </div>
// // //         </header>
// // //     );
// // // };

// // // export default Header;
// // import { useEffect, useRef, useState } from 'react';
// // import { useSelector } from 'react-redux';
// // import { useNavigate } from 'react-router-dom';
// // import {
// //   FiBell,
// //   FiLogOut,
// //   FiCalendar,
// //   FiUsers,
// //   FiMapPin,
// //   FiCreditCard
// // } from 'react-icons/fi';
// // import { useAuth } from '../../../hooks/useAuth';
// // import { getInitials } from '../../../utils/formatters';
// // import styles from './Header.module.scss';

// // const Header = ({ sidebarCollapsed }) => {
// //   const { user } = useSelector((state) => state.auth);
// //   const { logout } = useAuth();
// //   const navigate = useNavigate();

// //   const [showDropdown, setShowDropdown] = useState(false);
// //   const [showNotifications, setShowNotifications] = useState(false);

// //   const dropdownRef = useRef(null);
// //   const notificationRef = useRef(null);

// //   const notifications = [
// //     {
// //       id: 1,
// //       type: 'coach-booking',
// //       title: 'Coach booked',
// //       message: 'Rahul Sharma booked Coach Ajay Mehta.',
// //       route: '/admin/registrations/coaches/1',
// //       read: false,
// //       time: '2 min ago'
// //     },
// //     {
// //       id: 2,
// //       type: 'court-booking',
// //       title: 'Court booked',
// //       message: 'Priya Nair booked Court 3 at Victory Arena.',
// //       route: '/admin/registrations/courts/2',
// //       read: false,
// //       time: '8 min ago'
// //     },
// //     {
// //       id: 3,
// //       type: 'player-booking',
// //       title: 'Player booked',
// //       message: 'Arjun Verma booked Player Rakesh Singh.',
// //       route: '/admin/registrations/players/3',
// //       read: true,
// //       time: '15 min ago'
// //     },
// //     {
// //       id: 4,
// //       type: 'tournament-registration',
// //       title: 'Tournament registration',
// //       message: 'Sneha Patel registered for Summer Smash 2026.',
// //       route: '/admin/tournaments/registrations/4',
// //       read: false,
// //       time: '30 min ago'
// //     },
// //     {
// //       id: 5,
// //       type: 'vendor-payment',
// //       title: 'Vendor due paid',
// //       message: 'Vendor Elite Sports Club paid due amount of ₹12,500.',
// //       route: '/admin/vendors/payments/5',
// //       read: false,
// //       time: '1 hour ago'
// //     }
// //   ];

// //   const unreadCount = notifications.filter((item) => !item.read).length;

// //   useEffect(() => {
// //     const handleClickOutside = (e) => {
// //       if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
// //         setShowDropdown(false);
// //       }

// //       if (notificationRef.current && !notificationRef.current.contains(e.target)) {
// //         setShowNotifications(false);
// //       }
// //     };

// //     document.addEventListener('mousedown', handleClickOutside);
// //     return () => document.removeEventListener('mousedown', handleClickOutside);
// //   }, []);

// //   const handleLogout = () => {
// //     logout();
// //     setShowDropdown(false);
// //   };

// //   const handleNotificationClick = (notification) => {
// //     setShowNotifications(false);
// //     navigate(notification.route);
// //   };

// //   const getNotificationIcon = (type) => {
// //     switch (type) {
// //       case 'coach-booking':
// //         return <FiUsers size={16} />;
// //       case 'court-booking':
// //         return <FiMapPin size={16} />;
// //       case 'player-booking':
// //         return <FiUsers size={16} />;
// //       case 'tournament-registration':
// //         return <FiCalendar size={16} />;
// //       case 'vendor-payment':
// //         return <FiCreditCard size={16} />;
// //       default:
// //         return <FiBell size={16} />;
// //     }
// //   };

// //   return (
// //     <header className={`${styles.header} ${sidebarCollapsed ? styles.collapsed : ''}`}>
// //       <div className={styles.left} />

// //       <div className={styles.right}>
// //         <div className={styles.notificationMenu} ref={notificationRef}>
// //           <button
// //             type="button"
// //             className={styles.iconBtn}
// //             aria-label="Open notifications"
// //             onClick={() => {
// //               setShowNotifications((prev) => !prev);
// //               setShowDropdown(false);
// //             }}
// //           >
// //             <FiBell size={20} />
// //             {unreadCount > 0 && <span className={styles.badge}>{unreadCount}</span>}
// //           </button>

// //           {showNotifications && (
// //             <div className={styles.notificationDropdown}>
// //               <div className={styles.notificationHeader}>
// //                 <h4>Notifications</h4>
// //               </div>

// //               <div className={styles.notificationList}>
// //                 {notifications.length > 0 ? (
// //                   notifications.map((notification) => (
// //                     <button
// //                       key={notification.id}
// //                       type="button"
// //                       className={`${styles.notificationItem} ${
// //                         !notification.read ? styles.unread : ''
// //                       }`}
// //                       onClick={() => handleNotificationClick(notification)}
// //                     >
// //                       <div className={styles.notificationIcon}>
// //                         {getNotificationIcon(notification.type)}
// //                       </div>

// //                       <div className={styles.notificationContent}>
// //                         <span className={styles.notificationTitle}>
// //                           {notification.title}
// //                         </span>
// //                         <span className={styles.notificationMessage}>
// //                           {notification.message}
// //                         </span>
// //                         <span className={styles.notificationTime}>
// //                           {notification.time}
// //                         </span>
// //                       </div>
// //                     </button>
// //                   ))
// //                 ) : (
// //                   <div className={styles.emptyNotifications}>
// //                     No notifications found.
// //                   </div>
// //                 )}
// //               </div>
// //             </div>
// //           )}
// //         </div>

// //         <div className={styles.userMenu} ref={dropdownRef}>
// //           <button
// //             type="button"
// //             className={styles.userBtn}
// //             onClick={() => {
// //               setShowDropdown((prev) => !prev);
// //               setShowNotifications(false);
// //             }}
// //           >
// //             <div className={styles.avatar}>
// //               {user?.avatar ? (
// //                 <img src={user.avatar} alt={user.name} />
// //               ) : (
// //                 <span>{getInitials(user?.name || 'User')}</span>
// //               )}
// //             </div>

// //             <div className={styles.userInfo}>
// //               <span className={styles.userName}>{user?.name || 'User'}</span>
// //               <span className={styles.userRole}>{user?.role || 'Admin'}</span>
// //             </div>
// //           </button>

// //           {showDropdown && (
// //             <div className={styles.dropdown}>
// //               <button
// //                 type="button"
// //                 className={styles.dropdownItem}
// //                 onClick={handleLogout}
// //               >
// //                 <FiLogOut size={16} />
// //                 <span>Logout</span>
// //               </button>
// //             </div>
// //           )}
// //         </div>
// //       </div>
// //     </header>
// //   );
// // };

// // export default Header;
// import { useEffect, useRef, useState } from 'react';
// import { useSelector } from 'react-redux';
// import { useNavigate } from 'react-router-dom';
// import {
//   FiBell,
//   FiLogOut,
//   FiCalendar,
//   FiUsers,
//   FiMapPin,
//   FiCreditCard
// } from 'react-icons/fi';
// import { useAuth } from '../../../hooks/useAuth';
// import { getInitials } from '../../../utils/formatters';
// import styles from './Header.module.scss';

// const Header = ({ sidebarCollapsed }) => {
//   const { user } = useSelector((state) => state.auth);
//   const { logout } = useAuth();
//   const navigate = useNavigate();

//   const [showDropdown, setShowDropdown] = useState(false);
//   const [showNotifications, setShowNotifications] = useState(false);

//   const dropdownRef = useRef(null);
//   const notificationRef = useRef(null);

//   const notifications = [
//     {
//       id: 1,
//       type: 'coach-booking',
//       title: 'Coach booked',
//       message: 'Rahul Sharma booked Coach Ajay Mehta.',
//       route: '/coach-management/registrations',
//       read: false,
//       time: '2 min ago',
//     },
//     {
//       id: 2,
//       type: 'court-booking',
//       title: 'Court booked',
//       message: 'Priya Nair booked Court 3 at Victory Arena.',
//       route: '/court-management/:id/registrations',
//       read: false,
//       time: '8 min ago',
//     },
//     {
//       id: 3,
//       type: 'player-booking',
//       title: 'Player booked',
//       message: 'Arjun Verma booked Player Rakesh Singh.',
//       route: '/player-management/registrations',
//       read: true,
//       time: '15 min ago',
//     },
//     {
//       id: 4,
//       type: 'tournament-registration',
//       title: 'Tournament registration',
//       message: 'Sneha Patel registered for Summer Smash 2026.',
//       route: '/tournaments/:id/registrations',
//       read: false,
//       time: '30 min ago',
//     },
//     {
//       id: 5,
//       type: 'vendor-payment',
//       title: 'Vendor due paid',
//       message: 'Elite Sports Club paid due amount of ₹12,500.',
//       route: '/payments-revenue',
//       read: false,
//       time: '1 hour ago',
//     },
//   ];

//   const unreadCount = notifications.filter((item) => !item.read).length;

//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
//         setShowDropdown(false);
//       }

//       if (notificationRef.current && !notificationRef.current.contains(e.target)) {
//         setShowNotifications(false);
//       }
//     };

//     document.addEventListener('mousedown', handleClickOutside);
//     return () => document.removeEventListener('mousedown', handleClickOutside);
//   }, []);

//   const handleLogout = () => {
//     logout();
//     setShowDropdown(false);
//   };

//   const handleNotificationClick = (notification) => {
//     setShowNotifications(false);
//     navigate(notification.route);
//   };

//   const getNotificationIcon = (type) => {
//     switch (type) {
//       case 'coach-booking':
//         return <FiUsers size={16} />;
//       case 'court-booking':
//         return <FiMapPin size={16} />;
//       case 'player-booking':
//         return <FiUsers size={16} />;
//       case 'tournament-registration':
//         return <FiCalendar size={16} />;
//       case 'vendor-payment':
//         return <FiCreditCard size={16} />;
//       default:
//         return <FiBell size={16} />;
//     }
//   };

//   return (
//     <header className={`${styles.header} ${sidebarCollapsed ? styles.collapsed : ''}`}>
//       <div className={styles.left} />

//       <div className={styles.right}>
//         <div className={styles.notificationMenu} ref={notificationRef}>
//           <button
//             type="button"
//             className={styles.iconBtn}
//             aria-label="Open notifications"
//             onClick={() => {
//               setShowNotifications((prev) => !prev);
//               setShowDropdown(false);
//             }}
//           >
//             <FiBell size={20} />
//             {unreadCount > 0 && <span className={styles.badge}>{unreadCount}</span>}
//           </button>

//           {showNotifications && (
//             <div className={styles.notificationDropdown}>
//               <div className={styles.notificationHeader}>
//                 <h4>Notifications</h4>
//               </div>

//               <div className={styles.notificationList}>
//                 {notifications.length > 0 ? (
//                   notifications.map((notification) => (
//                     <button
//                       key={notification.id}
//                       type="button"
//                       className={`${styles.notificationItem} ${
//                         !notification.read ? styles.unread : ''
//                       }`}
//                       onClick={() => handleNotificationClick(notification)}
//                     >
//                       <div className={styles.notificationIcon}>
//                         {getNotificationIcon(notification.type)}
//                       </div>

//                       <div className={styles.notificationContent}>
//                         <span className={styles.notificationTitle}>
//                           {notification.title}
//                         </span>
//                         <span className={styles.notificationMessage}>
//                           {notification.message}
//                         </span>
//                         <span className={styles.notificationTime}>
//                           {notification.time}
//                         </span>
//                       </div>
//                     </button>
//                   ))
//                 ) : (
//                   <div className={styles.emptyNotifications}>
//                     No notifications found.
//                   </div>
//                 )}
//               </div>
//             </div>
//           )}
//         </div>

//         <div className={styles.userMenu} ref={dropdownRef}>
//           <button
//             type="button"
//             className={styles.userBtn}
//             onClick={() => {
//               setShowDropdown((prev) => !prev);
//               setShowNotifications(false);
//             }}
//           >
//             <div className={styles.avatar}>
//               {user?.avatar ? (
//                 <img src={user.avatar} alt={user.name} />
//               ) : (
//                 <span>{getInitials(user?.name || 'User')}</span>
//               )}
//             </div>

//             <div className={styles.userInfo}>
//               <span className={styles.userName}>{user?.name || 'User'}</span>
//               <span className={styles.userRole}>{user?.role || 'Admin'}</span>
//             </div>
//           </button>

//           {showDropdown && (
//             <div className={styles.dropdown}>
//               <button
//                 type="button"
//                 className={`${styles.dropdownItem} ${styles.dropdownItemDanger}`}
//                 onClick={handleLogout}
//               >
//                 <FiLogOut size={16} />
//                 <span>Logout</span>
//               </button>
//             </div>
//           )}
//         </div>
//       </div>
//     </header>
//   );
// };

// export default Header;
import { useCallback, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  FiBell,
  FiLogOut,
  FiCalendar,
  FiUsers,
  FiMapPin,
  FiCreditCard,
  FiUser,
  FiCheckCircle,
  FiRefreshCw,
} from 'react-icons/fi';
import { useAuth } from '../../../hooks/useAuth';
import { getInitials } from '../../../utils/formatters';
import { inAppNotificationService } from '../../../api/services/inAppNotification.service';
import styles from './Header.module.scss';

// ── Icon mapping based on notification icon field ─────────────────────────────
const ICON_MAP = {
  booking: <FiCalendar size={16} />,
  vendor: <FiUsers size={16} />,
  court: <FiMapPin size={16} />,
  coach: <FiUser size={16} />,
  player: <FiUsers size={16} />,
  tournament: <FiCalendar size={16} />,
  payment: <FiCreditCard size={16} />,
  system: <FiBell size={16} />,
};

// ── Relative time formatter ───────────────────────────────────────────────────
const formatRelativeTime = (dateStr) => {
  const diff = Date.now() - new Date(dateStr).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins} min ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs} hr ago`;
  return `${Math.floor(hrs / 24)} days ago`;
};

const POLL_INTERVAL_MS = 30_000;

const Header = ({ sidebarCollapsed }) => {
  const { user } = useSelector((state) => state.auth);
  const { logout } = useAuth();
  const navigate = useNavigate();

  const [showDropdown, setShowDropdown] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [markingAll, setMarkingAll] = useState(false);

  const dropdownRef = useRef(null);
  const notificationRef = useRef(null);
  const pollTimerRef = useRef(null);

  const recipientId = user?._id || user?.userId || user?.id;

  const fetchNotifications = useCallback(async () => {
    if (!recipientId) return;
    setLoading(true);
    try {
      const result = await inAppNotificationService.getNotifications(recipientId, { limit: 20, page: 1 });
      setNotifications(result?.data?.notifications || []);
      setUnreadCount(result?.data?.unreadCount ?? 0);
    } catch (err) {
      console.error('[Header] Failed to fetch notifications:', err?.message || err?.error || err);
    } finally {
      setLoading(false);
    }
  }, [recipientId]);

  useEffect(() => {
    fetchNotifications();
    pollTimerRef.current = setInterval(fetchNotifications, POLL_INTERVAL_MS);
    return () => clearInterval(pollTimerRef.current);
  }, [fetchNotifications]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) setShowDropdown(false);
      if (notificationRef.current && !notificationRef.current.contains(e.target)) setShowNotifications(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = () => { logout(); setShowDropdown(false); };

  const handleNotificationClick = async (notification) => {
    setShowNotifications(false);
    if (!notification.isRead) {
      try {
        await inAppNotificationService.markAsRead(notification._id);
        setNotifications((prev) => prev.map((n) => n._id === notification._id ? { ...n, isRead: true } : n));
        setUnreadCount((prev) => Math.max(0, prev - 1));
      } catch (e) { console.error('[Header] markAsRead failed:', e.message); }
    }
    if (notification.actionUrl) navigate(notification.actionUrl);
  };

  const handleMarkAllRead = async () => {
    if (!recipientId || markingAll) return;
    setMarkingAll(true);
    try {
      await inAppNotificationService.markAllAsRead(recipientId);
      setNotifications((prev) => prev.map((n) => ({ ...n, isRead: true })));
      setUnreadCount(0);
    } catch (e) { console.error('[Header] markAllAsRead failed:', e.message); }
    finally { setMarkingAll(false); }
  };

  const getNotificationIcon = (icon) => ICON_MAP[icon] || ICON_MAP.system;

  return (
    <header className={`${styles.header} ${sidebarCollapsed ? styles.collapsed : ''}`}>
      <div className={styles.left} />

      <div className={styles.right}>
        {/* Bell Icon */}
        <div className={styles.notificationMenu} ref={notificationRef}>
          <button
            type="button"
            id="header-bell-btn"
            className={styles.iconBtn}
            aria-label="Open notifications"
            onClick={() => { setShowNotifications((prev) => !prev); setShowDropdown(false); }}
          >
            <FiBell size={20} />
            {unreadCount > 0 && (
              <span className={styles.badge} aria-label={`${unreadCount} unread`}>
                {unreadCount > 99 ? '99+' : unreadCount}
              </span>
            )}
          </button>

          {showNotifications && (
            <div className={styles.notificationDropdown} id="header-notification-dropdown">
              <div className={styles.notificationHeader}>
                <h4>Notifications</h4>
                {unreadCount > 0 && (
                  <button
                    type="button"
                    className={styles.markAllBtn}
                    onClick={handleMarkAllRead}
                    disabled={markingAll}
                    title="Mark all as read"
                  >
                    {markingAll
                      ? <FiRefreshCw size={13} className={styles.spinning} />
                      : <FiCheckCircle size={13} />}
                    <span>{markingAll ? 'Marking…' : 'Mark all read'}</span>
                  </button>
                )}
              </div>

              <div className={styles.notificationList}>
                {loading && notifications.length === 0 ? (
                  Array.from({ length: 3 }).map((_, i) => (
                    <div key={i} className={styles.notificationSkeleton}>
                      <div className={styles.skeletonIcon} />
                      <div className={styles.skeletonContent}>
                        <div className={styles.skeletonLine} />
                        <div className={`${styles.skeletonLine} ${styles.skeletonShort}`} />
                      </div>
                    </div>
                  ))
                ) : notifications.length > 0 ? (
                  notifications.map((notification) => (
                    <button
                      key={notification._id}
                      type="button"
                      className={`${styles.notificationItem} ${!notification.isRead ? styles.unread : ''}`}
                      onClick={() => handleNotificationClick(notification)}
                    >
                      <div className={`${styles.notificationIcon} ${styles[notification.icon] || ''}`}>
                        {getNotificationIcon(notification.icon)}
                      </div>
                      <div className={styles.notificationContent}>
                        <span className={styles.notificationTitle}>{notification.title}</span>
                        <span className={styles.notificationMessage}>{notification.body}</span>
                        <span className={styles.notificationTime}>
                          {formatRelativeTime(notification.createdAt)}
                        </span>
                      </div>
                      {!notification.isRead && <span className={styles.unreadDot} aria-hidden="true" />}
                    </button>
                  ))
                ) : (
                  <div className={styles.emptyNotifications}>
                    <FiBell size={28} style={{ opacity: 0.3, marginBottom: 8 }} />
                    <p>No notifications yet</p>
                    <span>You&apos;re all caught up!</span>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

        <div className={styles.userMenu} ref={dropdownRef}>
          <button
            type="button"
            className={styles.userBtn}
            onClick={() => setShowDropdown((prev) => !prev)}
          >
            <div className={styles.avatar}>
              {user?.avatar ? (
                <img src={user.avatar} alt={user.name} />
              ) : (
                <span>{getInitials(user?.name || 'User')}</span>
              )}
            </div>

            <div className={styles.userInfo}>
              <span className={styles.userName}>{user?.name || 'User'}</span>
              <span className={styles.userRole}>{user?.role || 'Admin'}</span>
            </div>
          </button>

          {showDropdown && (
            <div className={styles.dropdown}>
              <button
                type="button"
                className={`${styles.dropdownItem} ${styles.dropdownItemDanger}`}
                onClick={handleLogout}
              >
                <FiLogOut size={16} />
                <span>Logout</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;